"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.Request = void 0;
const rxjs_1 = require("rxjs");
const ajax_1 = require("rxjs/ajax");
require("rxjs/internal/observable/dom/AjaxObservable");
const operators_1 = require("rxjs/operators");
const types_1 = require("./types");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const encodeToFormData = (data) => Object.keys(data && typeof data === 'object' ? data : {}).reduce((acc, key) => {
    const value = data[key];
    if (value !== undefined) {
        acc.append(key, value);
    }
    return acc;
}, new FormData());
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const encodeBody = (data, encoder) => {
    switch (encoder) {
        case types_1.BODY_ENCODER.json:
            return JSON.stringify(data);
        case types_1.BODY_ENCODER.formData:
            return encodeToFormData(data);
        default:
            return data;
    }
};
class Request {
    constructor(token, requestManager, options = {}) {
        this.prefix = ((options === null || options === void 0 ? void 0 : options.prefix) || '').replace(/\/+$/, '');
        this.execute = (method, url, data, executeOptions) => requestManager
            .run(() => rxjs_1.from(token.getToken()).pipe(operators_1.switchMap((accessToken) => {
            const { fileUpload, responseType, skipAuthorization } = executeOptions || {};
            const encoderType = fileUpload ? types_1.BODY_ENCODER.formData : types_1.BODY_ENCODER.json;
            const headerAuthorization = skipAuthorization
                ? {}
                : {
                    Authorization: `Bearer ${accessToken}`,
                };
            const config = {
                body: data ? encodeBody(data, encoderType) : undefined,
                headers: Object.assign(Object.assign({}, headerAuthorization), ((options === null || options === void 0 ? void 0 : options.headers) || {})),
                method: method.toUpperCase(),
                url: this.createUrl(url),
            };
            if (encoderType !== types_1.BODY_ENCODER.formData) {
                config.headers = Object.assign(config.headers, {
                    'Content-Type': 'application/json',
                });
            }
            if (responseType != null) {
                config.responseType = responseType;
            }
            return ajax_1.ajax(config);
        })))
            .pipe(operators_1.map((result) => ({
            data: result.response || null,
            meta: {
                status: result.status,
            },
        })), operators_1.take(1), operators_1.catchError((err) => {
            err.displayMessage =
                (err.status && err.response && err.response.message) ||
                    (err.status ? types_1.DEFAULT_SERVER_ERROR_MESSAGE : types_1.CONNECTION_TIMED_OUT_ERROR_MESSAGE);
            return rxjs_1.throwError(err);
        }));
    }
    createUrl(url) {
        return `${this.prefix}/${url.replace(/^\/+/, '')}`;
    }
}
exports.Request = Request;
//# sourceMappingURL=Request.js.map